export const LOGIN = 'auth/LOGIN';

export const setUser = (payload: any) => ({
  payload,
  type: LOGIN,
});
